import { MonitoringLog } from '../../../Controllers/CustomerServiceDashboard/CustomerServiceDashboard';
import { CustomerServiceDashboardState } from './CustomerServiceDashboardContext';
import { Action } from '../../hooks/useActionReducer';
import sortMonitoringLogsByUserName from './helpers/sortMonitoringLogsByUserName';
import sortMonitoringLogsByAccountNumber from './helpers/sortMonitoringLogsByAccountNumber';

export enum ActionType {
    FETCH_MONITORING_LOGS_REQUEST = 'FETCH_MONITORING_LOGS_REQUEST',
    FETCH_MONITORING_LOGS_SUCCESS = 'FETCH_MONITORING_LOGS_SUCCESS',
    FETCH_MONITORING_LOGS_FAILURE = 'FETCH_MONITORING_LOGS_FAILURE',
    SELECT_MONITORING_LOG = 'SELECT_MONITORING_LOG',
    FETCH_ALL_ACCOUNTS_REQUEST = 'FETCH_ALL_ACCOUNTS_REQUEST',
    FETCH_ALL_ACCOUNTS_SUCCESS = 'FETCH_ALL_ACCOUNTS_SUCCESS',
    FETCH_ALL_ACCOUNTS_FAILURE = 'FETCH_ALL_ACCOUNTS_FAILURE',
    FETCH_MONITORING_LOG_EVENT_REQUEST = 'FETCH_MONITORING_LOG_EVENT_REQUEST',
    FETCH_MONITORING_LOG_EVENT_SUCCESS = 'FETCH_MONITORING_LOG_EVENT_SUCCESS',
    FETCH_MONITORING_LOG_EVENT_FAILURE = 'FETCH_MONITORING_LOG_EVENT_FAILURE',
    FETCH_MONITORING_LOGS_BY_ACCOUNT_KEY_REQUEST = 'FETCH_MONITORING_LOGS_BY_ACCOUNT_KEY_REQUEST',
    FETCH_MONITORING_LOGS_BY_ACCOUNT_KEY_SUCCESS = 'FETCH_MONITORING_LOGS_BY_ACCOUNT_KEY_SUCCESS',
    FETCH_MONITORING_LOGS_BY_ACCOUNT_KEY_FAILURE = 'FETCH_MONITORING_LOGS_BY_ACCOUNT_KEY_FAILURE',
    CREATE_MONITORING_LOG_EVENT_REQUEST = 'CREATE_MONITORING_LOG_EVENT_REQUEST',
    CREATE_MONITORING_LOG_EVENT_SUCCESS = 'CREATE_MONITORING_LOG_EVENT_SUCCESS',
    CREATE_MONITORING_LOG_EVENT_FAILURE = 'CREATE_MONITORING_LOG_EVENT_FAILURE',
    UPDATE_MONITORING_LOG_EVENT_REQUEST = 'UPDATE_MONITORING_LOG_EVENT_REQUEST',
    UPDATE_MONITORING_LOG_EVENT_SUCCESS = 'UPDATE_MONITORING_LOG_EVENT_SUCCESS',
    UPDATE_MONITORING_LOG_EVENT_FAILURE = 'UPDATE_MONITORING_LOG_EVENT_FAILURE',
    DELETE_MONITORING_LOG_EVENT_REQUEST = 'DELETE_MONITORING_LOG_EVENT_REQUEST',
    DELETE_MONITORING_LOG_EVENT_SUCCESS = 'DELETE_MONITORING_LOG_EVENT_SUCCESS',
    DELETE_MONITORING_LOG_EVENT_FAILURE = 'DELETE_MONITORING_LOG_EVENT_FAILURE',
    FETCH_ALL_CONTRACTS_REQUEST = 'FETCH_ALL_CONTRACTS_REQUEST',
    FETCH_ALL_CONTRACTS_SUCCESS = 'FETCH_ALL_CONTRACTS_SUCCESS',
    FETCH_ALL_CONTRACTS_FAILURE = 'FETCH_ALL_CONTRACTS_FAILURE',
    FETCH_ACCOUNT_CONTRACTS_REQUEST = 'FETCH_ACCOUNT_CONTRACTS_REQUEST',
    FETCH_ACCOUNT_CONTRACTS_SUCCESS = 'FETCH_ACCOUNT_CONTRACTS_SUCCESS',
    FETCH_ACCOUNT_CONTRACTS_FAILURE = 'FETCH_ACCOUNT_CONTRACTS_FAILURE',
    SELECT_CONTRACT = 'SELECT_CONTRACT',
    CLEAR_SELECTED_CONTRACT = 'CLEAR_SELECTED_CONTRACT',
    FETCH_DISPLAYS_BY_CONTRACT_REQUEST = 'FETCH_DISPLAYS_BY_CONTRACT_REQUEST',
    FETCH_DISPLAYS_BY_CONTRACT_SUCCESS = 'FETCH_DISPLAYS_BY_CONTRACT_SUCCESS',
    FETCH_DISPLAYS_BY_CONTRACT_FAILURE = 'FETCH_DISPLAYS_BY_CONTRACT_FAILURE',
    SELECT_DISPLAY = 'SELECT_DISPLAY',
    CLEAR_SELECTED_DISPLAY = 'CLEAR_SELECTED_DISPLAY',
    FETCH_MONITORING_STATUS_ACCOUNT_LIST_REQUEST = 'FETCH_MONITORING_STATUS_ACCOUNT_LIST_REQUEST',
    FETCH_MONITORING_STATUS_ACCOUNT_LIST_SUCCESS = 'FETCH_MONITORING_STATUS_ACCOUNT_LIST_SUCCESS',
    FETCH_MONITORING_STATUS_ACCOUNT_LIST_FAILURE = 'FETCH_MONITORING_STATUS_ACCOUNT_LIST_FAILURE',
    FETCH_CUSTOMER_SERVICE_REPS_REQUEST = 'FETCH_CUSTOMER_SERVICE_REPS_REQUEST',
    FETCH_CUSTOMER_SERVICE_REPS_SUCCESS = 'FETCH_CUSTOMER_SERVICE_REPS_SUCCESS',
    FETCH_CUSTOMER_SERVICE_REPS_FAILURE = 'FETCH_CUSTOMER_SERVICE_REPS_FAILURE',
    FETCH_CUSTOMER_SERVICE_ASSIGNMENT_REQUEST = 'FETCH_CUSTOMER_SERVICE_ASSIGNMENT_REQUEST',
    FETCH_CUSTOMER_SERVICE_ASSIGNMENT_SUCCESS = 'FETCH_CUSTOMER_SERVICE_ASSIGNMENT_SUCCESS',
    FETCH_CUSTOMER_SERVICE_ASSIGNMENT_FAILURE = 'FETCH_CUSTOMER_SERVICE_ASSIGNMENT_FAILURE',
    FETCH_CUSTOMER_SERVICE_REP_ASSIGNED_ACCOUNTS_REQUEST = 'FETCH_CUSTOMER_SERVICE_REP_ASSIGNED_ACCOUNTS_REQUEST',
    FETCH_CUSTOMER_SERVICE_REP_ASSIGNED_ACCOUNTS_SUCCESS = 'FETCH_CUSTOMER_SERVICE_REP_ASSIGNED_ACCOUNTS_SUCCESS',
    FETCH_CUSTOMER_SERVICE_REP_ASSIGNED_ACCOUNTS_FAILURE = 'FETCH_CUSTOMER_SERVICE_REP_ASSIGNED_ACCOUNTS_FAILURE',
    SET_ACCOUNTS_VISIBLE_TO_USER = 'SET_ACCOUNTS_VISIBLE_TO_USER',
}

export type ActionHandlersType = {
    [K in ActionType]: (state: CustomerServiceDashboardState, action: Action) => CustomerServiceDashboardState;
};
interface ActionHandlerParams {
    state: CustomerServiceDashboardState;
    action?: Action;
}

const ActionHandlers: ActionHandlersType = {
    FETCH_MONITORING_LOGS_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                monitoringLogs: true,
            },
            error: null,
        };
    },
    FETCH_MONITORING_LOGS_SUCCESS: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_MONITORING_LOGS_SUCCESS action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                monitoringLogs: false,
            },
            monitoringLogs: action.payload,
            monitoringLogsByUser: sortMonitoringLogsByUserName(action.payload),
            monitoringLogsByAccountNumber: sortMonitoringLogsByAccountNumber(action.payload),
        };
    },
    FETCH_MONITORING_LOGS_FAILURE: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_MONITORING_LOGS_FAILURE action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                monitoringLogs: false,
            },
            error: action.payload,
        };
    },
    SELECT_MONITORING_LOG: (state, action) => {
        if (!action?.payload) {
            console.error('SELECT_MONITORING_LOG action is missing payload');
            return state;
        }
        return {
            ...state,
            selectedLog: action.payload,
        };
    },
    FETCH_ALL_ACCOUNTS_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                accounts: true,
            },
            error: null,
        };
    },
    FETCH_ALL_ACCOUNTS_SUCCESS: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_ALL_ACCOUNTS_SUCCESS action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                accounts: false,
            },
            accounts: action.payload,
        };
    },
    FETCH_ALL_ACCOUNTS_FAILURE: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_ALL_ACCOUNTS_FAILURE action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                accounts: false,
            },
            error: action.payload,
        };
    },
    FETCH_MONITORING_LOG_EVENT_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                monitoringLog: true,
            },
            error: null,
        };
    },
    FETCH_MONITORING_LOG_EVENT_SUCCESS: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_MONITORING_LOG_EVENT_SUCCESS action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                monitoringLog: false,
            },
            monitoringLog: action.payload,
        };
    },
    FETCH_MONITORING_LOG_EVENT_FAILURE: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_MONITORING_LOG_EVENT_FAILURE action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                monitoringLog: false,
            },
            error: action.payload,
        };
    },
    FETCH_MONITORING_LOGS_BY_ACCOUNT_KEY_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                monitoringLogsByAccountKey: true,
            },
            error: null,
        };
    },
    FETCH_MONITORING_LOGS_BY_ACCOUNT_KEY_SUCCESS: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_MONITORING_LOGS_BY_ACCOUNT_KEY_SUCCESS action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                monitoringLogsByAccountKey: false,
            },
            monitoringLogs: { ...state.monitoringLogs, [action.payload.accountNumber]: action.payload.monitoringLogs },
        };
    },
    FETCH_MONITORING_LOGS_BY_ACCOUNT_KEY_FAILURE: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_MONITORING_LOGS_BY_ACCOUNT_KEY_FAILURE action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                monitoringLogsByAccountKey: false,
            },
            error: action.payload,
        };
    },
    CREATE_MONITORING_LOG_EVENT_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                createMonitoringLog: true,
            },
            error: null,
        };
    },
    CREATE_MONITORING_LOG_EVENT_SUCCESS: (state, action) => {
        if (!action?.payload) {
            console.error('CREATE_MONITORING_LOG_EVENT_SUCCESS action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                createMonitoringLog: false,
            },
            monitoringLog: action.payload,
        };
    },
    CREATE_MONITORING_LOG_EVENT_FAILURE: (state, action) => {
        if (!action?.payload) {
            console.error('CREATE_MONITORING_LOG_EVENT_FAILURE action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                createMonitoringLog: false,
            },
            error: action.payload,
        };
    },
    UPDATE_MONITORING_LOG_EVENT_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                updateMonitoringLog: true,
            },
            error: null,
        };
    },
    UPDATE_MONITORING_LOG_EVENT_SUCCESS: (state, action) => {
        if (!action?.payload) {
            console.error('UPDATE_MONITORING_LOG_EVENT_SUCCESS action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                updateMonitoringLog: false,
            },
            monitoringLog: action.payload,
        };
    },
    UPDATE_MONITORING_LOG_EVENT_FAILURE: (state, action) => {
        if (!action?.payload) {
            console.error('UPDATE_MONITORING_LOG_EVENT_FAILURE action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                updateMonitoringLog: false,
            },
            error: action.payload,
        };
    },
    DELETE_MONITORING_LOG_EVENT_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                deleteMonitoringLog: true,
            },
            error: null,
        };
    },
    DELETE_MONITORING_LOG_EVENT_SUCCESS: (state, action) => {
        if (!action?.payload) {
            console.error('DELETE_MONITORING_LOG_EVENT_SUCCESS action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                deleteMonitoringLog: false,
            },
            monitoringLog: null,
        };
    },
    DELETE_MONITORING_LOG_EVENT_FAILURE: (state, action) => {
        if (!action?.payload) {
            console.error('DELETE_MONITORING_LOG_EVENT_FAILURE action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                deleteMonitoringLog: false,
            },
            error: action.payload,
        };
    },
    FETCH_ALL_CONTRACTS_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                contracts: true,
            },
            error: null,
        };
    },
    FETCH_ALL_CONTRACTS_SUCCESS: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_ALL_CONTRACTS_SUCCESS action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                contracts: false,
            },
            contracts: { ...state.contracts, ...action.payload },
        };
    },
    FETCH_ALL_CONTRACTS_FAILURE: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_ALL_CONTRACTS_FAILURE action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                contracts: false,
            },
            error: action.payload,
        };
    },
    FETCH_ACCOUNT_CONTRACTS_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                accountContracts: true,
            },
            error: null,
        };
    },
    FETCH_ACCOUNT_CONTRACTS_SUCCESS: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_ACCOUNT_CONTRACTS_SUCCESS action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                accountContracts: false,
            },
            accountContracts: { ...state.accountContracts, ...action.payload },
        };
    },
    FETCH_ACCOUNT_CONTRACTS_FAILURE: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_ACCOUNT_CONTRACTS_FAILURE action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                accountContracts: false,
            },
            error: action.payload,
        };
    },
    SELECT_CONTRACT: (state, action) => {
        if (!action?.payload) {
            console.error('SELECT_CONTRACT action is missing payload');
            return state;
        }
        return {
            ...state,
            selectedContract: { ...action.payload },
        };
    },
    CLEAR_SELECTED_CONTRACT: (state, action) => {
        return {
            ...state,
            selectedContract: null,
        };
    },
    FETCH_DISPLAYS_BY_CONTRACT_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                displaysByContract: true,
            },
            error: null,
        };
    },
    FETCH_DISPLAYS_BY_CONTRACT_SUCCESS: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_DISPLAYS_BY_CONTRACT_SUCCESS action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                displaysByContract: false,
            },
            displaysByContract: { ...state.displaysByContract, ...action.payload },
        };
    },
    FETCH_DISPLAYS_BY_CONTRACT_FAILURE: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_DISPLAYS_BY_CONTRACT_FAILURE action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                displaysByContract: false,
            },
            error: action.payload,
        };
    },
    SELECT_DISPLAY: (state, action) => {
        if (!action?.payload) {
            console.error('SELECT_DISPLAY action is missing payload');
            return state;
        }
        return {
            ...state,
            selectedDisplay: action.payload,
        };
    },
    CLEAR_SELECTED_DISPLAY: (state, action) => {
        return {
            ...state,
            selectedDisplay: null,
        };
    },
    FETCH_MONITORING_STATUS_ACCOUNT_LIST_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                monitoringStatusAccountList: true,
            },
            error: null,
        };
    },
    FETCH_MONITORING_STATUS_ACCOUNT_LIST_SUCCESS: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_MONITORING_STATUS_ACCOUNT_LIST_SUCCESS action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                monitoringStatusAccountList: false,
            },
            monitoringStatusAccountList: [...action.payload],
        };
    },
    FETCH_MONITORING_STATUS_ACCOUNT_LIST_FAILURE: (state, action) => {
        if (!action?.payload) {
            console.error('FETCH_MONITORING_STATUS_ACCOUNT_LIST_FAILURE action is missing payload');
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                monitoringStatusAccountList: false,
            },
            error: action.payload,
        };
    },
    FETCH_CUSTOMER_SERVICE_REPS_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                customerServiceReps: true,
            },
            error: null,
        };
    },
    FETCH_CUSTOMER_SERVICE_REPS_SUCCESS: (state, action) => {
        if (!action?.payload) {
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                customerServiceReps: false,
            },
            customerServiceReps: action.payload,
        };
    },
    FETCH_CUSTOMER_SERVICE_REPS_FAILURE: (state, action) => {
        if (!action?.payload) {
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                customerServiceReps: false,
            },
            error: action.payload,
        };
    },
    FETCH_CUSTOMER_SERVICE_ASSIGNMENT_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                assignments: true,
            },
            error: null,
        };
    },
    FETCH_CUSTOMER_SERVICE_ASSIGNMENT_SUCCESS: (state, action) => {
        if (!action?.payload) {
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                assignments: false,
            },
            accountNames: action.payload,
        };
    },
    FETCH_CUSTOMER_SERVICE_ASSIGNMENT_FAILURE: (state, action) => {
        if (!action?.payload) {
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                assignments: false,
            },
            error: action.payload,
        };
    },
    FETCH_CUSTOMER_SERVICE_REP_ASSIGNED_ACCOUNTS_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                repAssignedAccounts: true,
            },
            error: null,
        };
    },
    FETCH_CUSTOMER_SERVICE_REP_ASSIGNED_ACCOUNTS_SUCCESS: (state, action) => {
        if (!action?.payload) {
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                repAssignedAccounts: false,
            },
            repAssignedAccounts: { ...state.repAssignedAccounts, ...action.payload },
        };
    },
    FETCH_CUSTOMER_SERVICE_REP_ASSIGNED_ACCOUNTS_FAILURE: (state, action) => {
        if (!action?.payload) {
            return state;
        }
        return {
            ...state,
            loading: {
                ...state.loading,
                repAssignedAccounts: false,
            },
            error: action.payload,
        };
    },
    SET_ACCOUNTS_VISIBLE_TO_USER: (state, action) => {
        if (!action?.payload) {
            return state;
        }
        return {
            ...state,
            accountsVisibleToUser: [...state.accountsVisibleToUser, ...action.payload],
        };
    },
};
export default ActionHandlers;
